import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/wcandillon/tmp/tmp/react-native-redash/packages/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "coordinates"
    }}>{`Coordinates`}</h1>
    <p>{`In order to easily build certain types of animations, it can be extremely useful to switch from one coordinate system to another.`}</p>
    <p>{`For instance, to convert a `}<inlineCode parentName="p">{`x`}</inlineCode>{` and `}<inlineCode parentName="p">{`y`}</inlineCode>{` coordinate from the React Native canvas to a polar coordinate system centered at `}<inlineCode parentName="p">{`x = 100`}</inlineCode>{` and `}<inlineCode parentName="p">{`y = 100`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const x = 0;
const y = 100;
const center = { x: 100, y: 100 };
const {theta, radius} = cartesian2Polar(
  canvas2Cartesian({ x, y }, center)
);
// theta is π, radius: 100
`}</code></pre>
    <h2 {...{
      "id": "interfaces"
    }}>{`Interfaces`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`export interface Point {
    x: Animated.Adaptable<number>;
    y: Animated.Adaptable<number>;
}

export interface PolarPoint {
    theta: Animated.Adaptable<number>;
    radius: Animated.Adaptable<number>;
}
`}</code></pre>
    <hr></hr>
    <h2 {...{
      "id": "canvas2cartesian"
    }}><inlineCode parentName="h2">{`canvas2Cartesian()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`export declare const canvas2Cartesian: ({ x, y }: Point, center: Point) => {
    x: Animated.Node<number>;
    y: Animated.Node<number>;
};
`}</code></pre>
    <hr></hr>
    <h2 {...{
      "id": "cartesian2canvas"
    }}><inlineCode parentName="h2">{`cartesian2Canvas()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`export declare const cartesian2Canvas: ({ x, y }: Point, center: Point) => {
    x: Animated.Node<number>;
    y: Animated.Node<number>;
};
`}</code></pre>
    <hr></hr>
    <h2 {...{
      "id": "cartesian2polar"
    }}><inlineCode parentName="h2">{`cartesian2Polar()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`export declare const cartesian2Polar: ({ x, y }: Point) => {
    theta: Animated.Node<number>;
    radius: Animated.Node<number>;
};
`}</code></pre>
    <hr></hr>
    <h2 {...{
      "id": "polar2cartesian"
    }}><inlineCode parentName="h2">{`polar2Cartesian()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`export declare const polar2Cartesian: ({ theta, radius }: PolarPoint) => {
    x: Animated.Node<number>;
    y: Animated.Node<number>;
};
`}</code></pre>
    <hr></hr>
    <h2 {...{
      "id": "polar2canvas"
    }}><inlineCode parentName="h2">{`polar2Canvas()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`export declare const polar2Canvas: ({ theta, radius }: PolarPoint, center: Point) => {
    x: Animated.Node<number>;
    y: Animated.Node<number>;
};
`}</code></pre>
    <h2 {...{
      "id": "canvas2polar"
    }}><inlineCode parentName="h2">{`canvas2Polar()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`export declare const canvas2Polar: ({ x, y }: Point, center: Point) => {
    theta: Animated.Node<number>;
    radius: Animated.Node<number>;
};
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      